// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3hADg","label":"Radio_label__2ik6Q","checkMark":"Radio_checkMark__2lfF3","disabled":"Radio_disabled__2Y9fq"};